import { generateSessionId } from 'components/Chatbot/helpers/utils';
import { slice } from './slice';
import { Dispatch } from 'redux';

export const onUserLogin = () => (dispatch: Dispatch) => {
  const savedSessionId = localStorage.getItem('chatbot_session_id');
  if (!savedSessionId) {
    const newSessionId = generateSessionId();
    localStorage.setItem('chatbot_session_id', newSessionId);
  }
  dispatch(slice.actions.setSessionId(localStorage.getItem('chatbot_session_id') || ''));
};
const chatbotActions = {
  ...slice.actions,
  onUserLogin,
};

export default chatbotActions;
